export const isJobsite = ({ jobsite, pointOfDelivery }): boolean =>
  !pointOfDelivery || jobsite.jobsiteCode === pointOfDelivery.pointOfDeliveryCode;

export const isPointOfDelivery = ({ jobsite, pointOfDelivery }): boolean =>
  !!pointOfDelivery &&
  (jobsite.jobsiteCode !== pointOfDelivery.pointOfDeliveryCode && !!pointOfDelivery.pointOfDeliveryCode);

export const renderLocationDesc = (order): string =>
  isPointOfDelivery(order)
    ? `${order.pointOfDelivery.pointOfDeliveryCode} ${order.pointOfDelivery.pointOfDeliveryDesc}`
    : `${order && order.jobsite && order.jobsite.jobsiteCode} ${order && order.jobsite && order.jobsite.jobsiteDesc}`;
